import { RouteObject } from "react-router-dom";

import { adminGeneralRoutes } from "../admin/general";
import { userGeneralRoutes } from "./general";

export const userRoutes: RouteObject[] = [
  ...userGeneralRoutes,
  ...adminGeneralRoutes,
];
